import { TimezoneOption } from './types';

const DEFAULT_TZ = 'Etc/UTC';

export const DEFAULT_TIMEZONE_OPTION: TimezoneOption = {
  label: DEFAULT_TZ,
  value: DEFAULT_TZ
};
